import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {

    /** Field not empty */
    static required(fieldName: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return control.value ? null : { required: `${fieldName} is required` };
        };
    }

    /** Valid email*/
    static email(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(control.value) ? null : { email: 'Invalid email format' };
        };
    }

    /** numeric field*/
    static numeric(fieldName: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return /^[0-9]+$/.test(control.value) ? null : { numeric: `${fieldName} must be a number` };
        };
    }

    /** minimun length */
    static minLength(fieldName: string, length: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return control.value && control.value.length >= length
                ? null
                : { minLength: `${fieldName} must be at least ${length} characters` };
        };
    }


    static passwordValidator(fieldName: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value || '';
            if (value.length < 7 || value.length > 32) {
                return {
                    passwordLength: `${fieldName} Must be between 7 and 32 characters long.`,
                };
            }
            const hasLetter = /[a-zA-Z]/.test(value);
            const hasNumber = /\d/.test(value);

            if (!hasLetter || !hasNumber) {
                return {
                    lettersAndNumbers: `${fieldName} Must contain both letters and numbers.`,
                };
            }

            return null;
        };
    }

    static greaterThanZero(fieldName: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = parseFloat(control.value);
            if (isNaN(value) || value <= 0) {
                return {
                    greaterThanZero: `${fieldName} Must be greater than 0.`,
                };
            }

            return null;
        };
    }


    static atLeastOneLetter(fieldName: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value?.trim() || '';
            const hasLetter = /[a-zA-Z]/.test(value);
            return hasLetter ? null : {
                noLetter: `${fieldName} must contain at least one letter.`,
            };
        };
    }

    static zipCodeValidator(countrySelected: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {

            const country = countrySelected;
            const zip = control.value;

            if (country === 'US') {
                const hasLetters = /[a-zA-Z]/.test(zip);
                if (hasLetters) {
                    return { invalidUSZip: 'ZIP Code must not contain letters' };
                }

                const zipRegex = /^(\d{5})(-?\d{4})?$/;
                if (!zipRegex.test(zip)) {
                    return { invalidUSZip: 'ZIP Code must be 5 digits or 9 digits' };
                }
            }
            if (country !== 'US') {
                const zipRegex = /^[A-Za-z0-9\- ]{3,10}$/;
                if (!zipRegex.test(zip)) {
                    return { invalidUSZip: 'Postal Code must be 3–10 letters or number' };
                }

            }

            return null;
        };
    }

    static lettersNumbersWithoutSpaces(fieldName: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.parent) return null;

            const value = control.value?.trim() || '';
            const regex = /^[A-Za-z0-9]+$/.test(value);

            return regex ? null : {
                noValid: `${fieldName} can only contain letters and numbers, no spaces.`,
            };
        };
    }


    // Only allow numbers, dashes, spaces and parentheses.
    static numberValidator(fieldName: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.parent) return null;

            const value = control.value?.trim() || '';
            if (!value) return null;
            const regex = /^[0-9\s\-\(\)]+$/.test(value);

            return regex ? null : {
                noValid: `${fieldName} invalid characters.`,
            };
        };
    }

    // Only allow numbers, dashes, spaces, parentheses and plus sign.
    static internationalPhoneNumberValidator(fieldName: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.parent) return null;

            const value = control.value?.trim() || '';
            if (!value) return null;
            const regex = /^[0-9\s\-\+\(\)]+$/.test(value);

            return regex ? null : {
                noValid: `${fieldName} invalid characters.`,
            };
        };
    }


}


